import type { Review, ReviewTopic } from "@/types/content";

export const reviewTopics: ReviewTopic[] = [
  {
    id: "t1",
    title: "科幻新浪潮：当想象力抵达边界",
    intro:
      "从云端都市到银河尽头，这一批科幻作品不再只谈论技术，而是把镜头对准了人本身。我们把近期最值得细读的科幻影视与影评整理成这一期专题，聊聊想象力的边界，以及边界之外的那些心事。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20cosmic%20nebula%20with%20glowing%20light%20lines%2C%20editorial%20science%20fiction%20theme%20banner%2C%20cinematic%20no%20text&width=1200&height=675&seq=topic-t1&orientation=landscape",
    workIds: ["m2", "m6", "s8", "s5", "s3"],
  },
  {
    id: "t2",
    title: "悬疑罪案：在黑暗中寻找真相",
    intro:
      "一个好的悬疑故事，卖点从来不是凶手是谁，而是我们为什么愿意跟着主角一起走进黑暗。这一期专题收录近期口碑最好的悬疑罪案影视与深度影评，看看它们如何把「真相」拆成一层又一层。",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20city%20in%20fog%20with%20a%20single%20warm%20street%20lamp%2C%20editorial%20crime%20mystery%20theme%20banner%2C%20cinematic%20no%20text&width=1200&height=675&seq=topic-t2&orientation=landscape",
    workIds: ["m1", "m7", "s1", "s7"],
  },
  {
    id: "t3",
    title: "华语现实主义：把日子拍成电影",
    intro:
      "没有奇观，没有反转，只有一条老街、一间急诊室、一段说不出口的告别。华语现实主义作品的动人之处，往往在于它拍的就是我们自己的日子。这一期，我们慢下来，读一些温柔而认真的影评。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20afternoon%20light%20on%20an%20old%20chinese%20street%2C%20editorial%20humanist%20cinema%20theme%20banner%2C%20cinematic%20no%20text&width=1200&height=675&seq=topic-t3&orientation=landscape",
    workIds: ["m5", "m8", "s6"],
  },
];

export const reviews: Review[] = [
  {
    id: "r1",
    topicId: "t1",
    workId: "m2",
    title: "《云端之上》：把乌托邦悬在半空的勇气",
    author: "陆时",
    excerpt:
      "它本可以拍成一部视觉爽片，但导演选择了更难的路——让每一个壮丽的镜头，都成为一次道德拷问。",
    content: [
      "《云端之上》最聪明的地方，是它把「未来」拍得非常安静。云城的街道干净得近乎失真，人们说话轻声细语，仿佛只要不吵醒什么，这个世界就能一直这样运转下去。",
      "但诺亚的发现打破了这个幻觉。影片真正的冲突不是人与技术，而是安逸与良知。当一座城市的存续需要另一片废墟来偿还，居住其中的人该如何自处？",
      "伊桑·科尔的表演克制到近乎吝啬，他把所有的挣扎都收在眼神里。结尾那段没有配乐的独白，是全片最有力量的三分钟。",
      "如果你期待的是炫技式科幻，也许会觉得它慢；但如果你愿意慢下来，它会给你一个久久散不去的问句。",
    ],
    date: "2025-11-20",
    readTime: 6,
  },
  {
    id: "r2",
    topicId: "t1",
    workId: "m6",
    title: "《星际信使》：孤独是这场对话唯一的语言",
    author: "江浸月",
    excerpt:
      "当通讯延迟从分钟变成数年，一个人的航行就变成了人类最漫长的等待。这部电影把孤独拍出了史诗感。",
    content: [
      "影片开场十分钟几乎没有台词，只有舱内的机械声和引擎的低鸣。导演用这种近乎苛刻的安静，先让你习惯孤独，再让你爱上孤独。",
      "艾略特与地面指挥薇拉之间的通讯，是整部电影的情感主轴。时间差让他们的对话永远错位——他说的每句话，对方要等上数年才能听见。这种错位，恰恰是所有异地关系的极端隐喻。",
      "IMAX 画幅下的星云镜头美得近乎霸道，但真正让人记住的，是艾略特在舷窗前留下的一张全家福。",
    ],
    date: "2026-02-19",
    readTime: 7,
  },
  {
    id: "r3",
    topicId: "t1",
    workId: "s8",
    title: "《银河边缘》：群像冒险的教科书式开篇",
    author: "周无",
    excerpt:
      "一集立人设，两集建世界，三集就把观众的心绑在飞船上。这套剧集的开篇节奏，值得所有长篇剧集学习。",
    content: [
      "《银河边缘》最厉害的一点，是它从不急着介绍世界观。观众和船员一样，对前方一无所知，只能在一次次危机中拼凑出这个宇宙的规则。",
      "船长洛克不是传统意义上的英雄，他会算错、会犹豫、会在关键时刻把选择权交给别人。正是这种不完美，让群像戏有了呼吸感。",
      "配乐是隐藏的主角，主题曲只在每集最后三十秒响起，却每次都能把情绪顶到最满。",
    ],
    date: "2026-05-22",
    readTime: 5,
  },
  {
    id: "r4",
    topicId: "t1",
    workId: "s5",
    title: "《深海迷航》：恐惧不是来自深海，而是沉默",
    author: "林深",
    excerpt:
      "真正的恐惧从来不是怪物本身，而是你开始怀疑，船上那个最冷静的人，是不是早就知道了什么。",
    content: [
      "《深海迷航》把惊悚建立了「信息差」上。观众和角色知道的一样少，每一个镜头的空白都像在暗示什么。",
      "潜艇内部的空间调度极其克制，狭窄的走廊、忽明忽暗的应急灯，让幽闭恐惧在无声中积累。",
      "当谜底揭晓时，你会发现最可怕的不是深海里的那个东西，而是人类面对未知时做出的选择。",
    ],
    date: "2026-03-27",
    readTime: 5,
  },
  {
    id: "r5",
    topicId: "t1",
    workId: "s3",
    title: "《时光代理人》：单元剧如何讲出连续剧的野心",
    author: "阿澈",
    excerpt:
      "每一集都是独立委托，每一集又都在为主线埋伏笔。这种结构玩好了是神作，玩砸了是缝合怪，而它显然属于前者。",
    content: [
      "「回到过去替人办事」这个设定本身并不新鲜，但《时光代理人》把重点放在了「办完事之后」——那些被修改的时间线，如何反噬委托人自己。",
      "单元故事质量稳定，第 6 集关于一位母亲的委托，是近年来少见的克制催泪。",
      "真正让人期待的是主线：程野为什么无法改变自己的过去。当这个悬念被一点点掀开，整部剧的格局才真正打开。",
    ],
    date: "2025-08-02",
    readTime: 6,
  },
  {
    id: "r6",
    topicId: "t2",
    workId: "m1",
    title: "《暗夜追光》：雨夜、旧案与不肯熄灭的光",
    author: "陆时",
    excerpt:
      "它没有急着给你答案，而是先让你淋一场雨。等浑身湿透，你才明白主角为什么要一直往前追。",
    content: [
      "《暗夜追光》的氛围营造堪称华语悬疑的近年巅峰。雨水几乎贯穿全片，霓虹在水面上被打碎、重组，像极了被反复推翻的案情。",
      "林峯饰演的周野没有英雄光环，他查案的方式笨拙而执拗，甚至一再把自己推进危险的境地。这种不精明，反而让人信服。",
      "影片最大的赌注是放弃了大场面追车戏，把高潮放在一场只有两个人的对话里。事实证明，这个选择是对的。",
      "那句「有些黑暗，只能用光去追」，散场后仍会在耳边回响。",
    ],
    date: "2026-01-22",
    readTime: 7,
  },
  {
    id: "r7",
    topicId: "t2",
    workId: "m1",
    title: "谁是那个「信任的人」——《暗夜追光》人物关系拆解",
    author: "苏黎",
    excerpt:
      "把三个主要人物放回十二年前的时间坐标，你会发现，导演早在开场就埋好了所有答案。",
    content: [
      "周野、苏婉与陆行，三个人分别代表了「追」、「记」与「拼」。他们联手才有机会接近真相，可偏偏每个人都在独自扛着什么。",
      "苏婉这条线被很多观众低估了。她不是查案的工具人，而是唯一敢于公开提问的人，她的出现让案件从「内部问题」变成了「公共事件」。",
      "如果重看一遍，你会注意到陆行的每一次沉默都不是因为他知道得多，而是因为他不敢确认。",
    ],
    date: "2026-01-28",
    readTime: 6,
  },
  {
    id: "r8",
    topicId: "t2",
    workId: "s1",
    title: "《迷雾之城》：一座城的心事，藏在雾里",
    author: "江浸月",
    excerpt:
      "它把「雾」用成了一个角色。雾不只是氛围，更是这座工业城市无法言说的记忆。",
    content: [
      "《迷雾之城》最独特的地方，是它把城市本身当成主角来写。工厂的烟囱、废弃的家属院、常年不散的雾，共同构成了一个关于「被遗忘」的隐喻。",
      "刑侦线节奏紧凑，但导演从不吝啬给环境镜头。那些缓慢的空镜，恰恰是这部剧的呼吸。",
      "沈默这个角色写得极好，他的执拗不是天生，而是被这座城市一点一点磨出来的。",
    ],
    date: "2026-01-18",
    readTime: 6,
  },
  {
    id: "r9",
    topicId: "t2",
    workId: "m7",
    title: "《无声证词》：最安静的地方，藏着最响的真相",
    author: "周无",
    excerpt:
      "一段被消音的录音，成了整部电影的心脏。导演用「听不见」的过程，讲了一个关于「不被听见」的故事。",
    content: [
      "《无声证词》的法庭戏拍得极其克制，没有煽情的陈词，只有证据之间冷静的碰撞。",
      "李在勋与金素妍的对手戏张力十足，检察官与律师的每一次交锋，都像在下一盘看不到终局的棋。",
      "影片真正的锋利之处，在于它提出了一个问题：当真相需要被翻译，它还算不算真相？",
    ],
    date: "2025-09-26",
    readTime: 5,
  },
  {
    id: "r10",
    topicId: "t2",
    workId: "s7",
    title: "《罪案心理师》：当侧写师成为嫌疑人",
    author: "林深",
    excerpt:
      "它把经典的「侧写师反被追查」桥段拍出了新意，靠的不是反转，而是角色的自我怀疑。",
    content: [
      "车贤这个角色的迷人之处，在于他所有的专业能力，最终都变成了针对自己的武器。他越理解凶手，越无法证明自己的清白。",
      "韩瑞妍作为搭档的存在感极强，她提供的不是感情线，而是一面「理性」的镜子。",
      "第 8 集的长镜头几乎是一次炫技，却牢牢服务了剧情，是整季的高光时刻。",
    ],
    date: "2026-04-10",
    readTime: 6,
  },
  {
    id: "r11",
    topicId: "t3",
    workId: "m5",
    title: "《长街旧梦》：把时间调慢一点，再慢一点",
    author: "苏黎",
    excerpt:
      "它不急着讲一个完整的故事，而是先让你在老街的味道里坐一会儿。等心静下来，故事自然就开始了。",
    content: [
      "《长街旧梦》是一部关于「慢」的电影。修表匠的手、老街的光、邻里间闲散的对话，构成了它全部的质感。",
      "父女线没有激烈的争吵，所有的和解都发生在沉默里——一次递茶，一句没头没尾的叮嘱。",
      "结尾那只重新走动的旧表，是全片最温柔也最有力的隐喻：有些东西停过，但没坏。",
    ],
    date: "2024-10-08",
    readTime: 6,
  },
  {
    id: "r12",
    topicId: "t3",
    workId: "m8",
    title: "《山与海之间》：一封写给失去的长信",
    author: "江浸月",
    excerpt:
      "它把旅行拍成了一种疗愈方式。从山顶到海边，每一步都像是在替观众说出那些堵在胸口的话。",
    content: [
      "影片的结构像一次徒步：缓慢、重复、偶有惊喜。正是这种节奏，让情绪的积累显得真实。",
      "陈柏言与吴雨晴的表演自然到几乎没有痕迹，他们不像在演，更像真的在赶路。",
      "当小岚终于按下快门，观众才明白，她拍下的从来不是父亲的背影，而是自己学会告别的瞬间。",
    ],
    date: "2025-07-04",
    readTime: 5,
  },
  {
    id: "r13",
    topicId: "t3",
    workId: "s6",
    title: "《医者仁心》：医院走廊里的众生相",
    author: "陆时",
    excerpt:
      "它没有把医生塑造成神明，也没有把病人简化成病例，而是老老实实地拍了一群普通人的坚持。",
    content: [
      "这部剧最大的优点是不煽情。抢救失败就是失败，没有奇迹，只有继续下一个病人。",
      "江川与苏晚的关系写得高级——不是爱情，而是同一种职业信念下的惺惺相惜。",
      "第 20 集那位坚持出院的老人，是整季最有力量的配角故事，没有之一。",
    ],
    date: "2025-05-30",
    readTime: 6,
  },
];